import { Fragment } from "react";
import { Button, Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import moment from "moment";
import "./passCard.css";
import $ from "jquery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";

const PassCard = (props) => {
    const { t } = useTranslation();
    const { pass, i, allowedPermission, onProceed, smallCard, discountCode } = props;

    return (
        <Card id={`passCard${i}`} className={`${smallCard ? "shadow-sm" : "shadow"} pass-card`}>
            <Card.Body>
                <p className="d-inline-block pass-title mb-0">{pass.pass_name}</p>
                <p className="d-inline-block float-end pass-price mb-0">
                    {/* <FontAwesomeIcon icon={faMoneyBill} className="me-2" /> */}
                    {discountCode ? (
                        <>
                            {discountCode.discount_rate || discountCode.discount_value ? (
                                <>
                                    <del>
                                        {pass.pass_price} {t("currency")}
                                    </del>
                                    <span>
                                        {discountCode.discount_value
                                            ? pass.pass_price - discountCode.discount_value < 0
                                                ? 0
                                                : pass.pass_price - discountCode.discount_value
                                            : discountCode.discount_rate
                                            ? ((100 - discountCode.discount_rate) * pass.pass_price) / 100
                                            : null}{" "}
                                        {t("currency")}
                                    </span>
                                </>
                            ) : (
                                <>
                                    {pass.pass_price} {t("currency")}
                                </>
                            )}
                        </>
                    ) : (
                        <>
                            {pass.pass_price} {t("currency")}
                        </>
                    )}
                </p>

                {pass.pass_descr && <p className="mt-3">{pass.pass_descr}</p>}

                <p className="mb-0 mt-3">
                    {t("entrances")}: <strong>{pass.pass_entries}</strong>
                </p>
                <p className="mb-0">
                    {t("validFor")}: <strong>{pass.pass_duration_days}</strong>{" "}
                    {t(pass.pass_duration_days === 1 ? "day" : "days")} {t("sinceFirstVisit")}.
                </p>
                <p className={pass.pass_quantity !== null || pass.pass_user_limit !== null ? "mb-0" : ""}>
                    {t("activationTill")} <strong>{moment(pass.pass_due_date).format("DD.MM.YYYY")}</strong>.
                </p>
                {pass.pass_quantity !== null && (
                    <p className={pass.pass_user_limit !== null ? "mb-0" : ""}>
                        <strong>
                            {pass.countPurchases < 3 && (
                                <FontAwesomeIcon icon={faWarning} className="text-warning me-2" />
                            )}
                            {pass.countPurchases === 1
                                ? t("passes.leftPasses.onePass", { quantity: 1 })
                                : pass.countPurchases >= 2 && pass.countPurchases <= 4
                                ? t("passes.leftPasses.twoFourPasses", { quantity: pass.countPurchases })
                                : t("passes.leftPasses.fiveMorePasses", { quantity: pass.countPurchases })}
                        </strong>
                    </p>
                )}
                {pass.pass_user_limit !== null && (
                    <p>
                        {t("passes.limitForOneUser")}: <strong>{pass.pass_user_limit}</strong>
                    </p>
                )}
                {!smallCard && (
                    <Fragment>
                        <p>
                            {t("validForEntryToClasses")}:<br />
                            {pass.class_types.map((c, j) => (
                                <Fragment key={j}>
                                    <strong>
                                        {c.class_type_name}
                                        {j < pass.class_types.length - 1 ? ", " : "."}
                                    </strong>
                                </Fragment>
                            ))}
                        </p>
                        <p className="text-center">
                            {!allowedPermission || pass.countPurchases === 0 || pass.alreadyPurchased ? (
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="tooltip-disabled">
                                            {t(
                                                !allowedPermission
                                                    ? "error.yourAccountHasNotBeenConfirmed"
                                                    : pass.countPurchases === 0
                                                    ? "passes.passSoldOut"
                                                    : pass.alreadyPurchased
                                                    ? "passes.passAlreadyPurchased"
                                                    : ""
                                            )}
                                        </Tooltip>
                                    }
                                >
                                    <span className="d-inline-block">
                                        <Button
                                            disabled
                                            style={{ pointerEvents: "none" }}
                                            variant="primary"
                                            size="lg"
                                            className="py-1 px-5"
                                        >
                                            {t("choose")}
                                        </Button>
                                    </span>
                                </OverlayTrigger>
                            ) : (
                                <Button
                                    variant="primary"
                                    size="lg"
                                    className="py-1 px-5"
                                    onClick={() => {
                                        $(".pass-card").removeClass("selected-pass");
                                        $(`#passCard${i}`).addClass("selected-pass");
                                        onProceed();
                                    }}
                                >
                                    {t("choose")}
                                </Button>
                            )}
                        </p>
                    </Fragment>
                )}
            </Card.Body>
        </Card>
    );
};

export default PassCard;
